import { ReportingControllerBaseConfig } from '../../../../base';
import { FormCollectionController } from './formCollectionInterface';
import { FormCollectionViewProps } from './formCollectionProps';
import { CollectionController } from '../../../common/collection';

export function createFormCollectionController(
    config: ReportingControllerBaseConfig & {
        collection: {
            controller: CollectionController;
        };
    }
): FormCollectionController {
    const {
        collection: { controller: collectionController },
    } = config;

    return {
        useProps(context, item, props): FormCollectionViewProps {
            const collection = collectionController.useProps(
                context,
                item.collection,
                props.collection
            );
            return {
                collection,
            };
        },
    };
}
